import createActionType from "@/redux/utils/createActionType";

export const MODULE = "collaboration";

export const SET_SOCKET_INSTANCE = createActionType(MODULE, "setSocketInstance");
export const SET_REFERENCE = createActionType(MODULE, "setReference");
export const SET_USER_ID = createActionType(MODULE, "setUserId");
export const SET_IS_LOADING = createActionType(MODULE, "setIsLoading");
export const SET_ALL_MESSAGES = createActionType(MODULE, "setAllMessages");
export const SET_ATTACHED_FILES_EDITOR = createActionType(MODULE, "setAttachedFilesEditor");
export const SET_ALL_NOTIFICATIONS = createActionType(MODULE, "setAllNotifications");
export const SET_ALL_COMPANY_USERS = createActionType(MODULE, "setAllCompanyUsers");
export const SET_TO_EDIT_MESSAGE = createActionType(MODULE, "setToEditMessage");
export const SET_IS_UPLOAD_FILE = createActionType(MODULE, "setIsUploadFile");
export const SET_IS_PENDING = createActionType(MODULE, "setIsPending");
export const SET_ATTACHMENT_FILES = createActionType(MODULE, "setAttachmentFiles");
export const ADD_ATTACHMENT_FILE = createActionType(MODULE, "addAttachmentFile");
export const REMOVE_ATTACHMENT_FILE = createActionType(MODULE, "removeAttachmentFile");
export const SET_ATTACHMENTS_TO_UPLOAD = createActionType(MODULE, "setAttachmentsToUpload");
export const APPEND_ATTACHMENTS_TO_UPLOAD = createActionType(MODULE, "appendAttachmentsToUpload");
export const UPDATE_MESSAGE_LABELS = createActionType(MODULE, "updateMessageLabels");
export const UPDATE_MESSAGE_FILE_LABELS = createActionType(MODULE, "updateMessageFileLabels");

export const RESET = createActionType(MODULE, "reset");
